/** CPU reference gradient evaluation; the GPU samples the baked atlas row. */
export function evalGradient(def, t, out = [0, 0, 0, 0]) {
    const stops = [...def.stops].sort((a, b) => a.t - b.t);
    if (stops.length === 0) {
        out[0] = out[1] = out[2] = out[3] = 1;
        return out;
    }
    if (t <= stops[0].t || stops.length === 1)
        return copy(stops[0].color, out);
    const last = stops[stops.length - 1];
    if (t >= last.t)
        return copy(last.color, out);
    let i = 0;
    while (i < stops.length - 2 && t >= stops[i + 1].t)
        i++;
    const a = stops[i];
    const b = stops[i + 1];
    if (def.mode === 'stepped')
        return copy(a.color, out);
    const span = b.t - a.t;
    const s = span <= 1e-8 ? 1 : (t - a.t) / span;
    for (let c = 0; c < 4; c++)
        out[c] = a.color[c] + (b.color[c] - a.color[c]) * s;
    return out;
}
function copy(src, out) {
    out[0] = src[0];
    out[1] = src[1];
    out[2] = src[2];
    out[3] = src[3];
    return out;
}
export function gradientStop(t, color) {
    return { t, color };
}
